"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//

exports.default = {
  props: ["method"]
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/Method.vue
// module id = gY4u
// module chunks = 0 1